import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { Subject } from "rxjs";

@Injectable()
export class PaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  firstPageLabel = `Første side`;
  itemsPerPageLabel = `Elementer per side`;
  lastPageLabel = `Sidste side`;

  nextPageLabel = 'Næste side';
  previousPageLabel = 'Forrige side';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `Side 1 af 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Side ${page + 1} af ${amountPages}`;
  }
}